export const FLOATING_BUTTON_SECTION_HASH = 'FLOATING_BUTTON'

export const FLOATING_BUTTON_SECTION_TITLE = 'Floating Button'
